import { render, staticRenderFns } from "./ListingItem.vue?vue&type=template&id=01ca7084"
import script from "./ListingItem.vue?vue&type=script&lang=js"
export * from "./ListingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports